export default {
    FULL: '100',
    PARTIAL_75: '75',
    PARTIAL_50: '50',
    PARTIAL_25: '25',
    UNFINISHED_NO: '0',
};
